import { useEffect, useRef, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { FiChevronDown } from 'react-icons/fi';
import { IoIosCloseCircle } from 'react-icons/io';
import { MdOutlineClose } from 'react-icons/md';
import { useSelector } from 'react-redux';
import '../styles/NewTableComponent.css';
import { customStyles } from '../utils/helper';
import { searchIcon } from '../utils/svgs';
import Filters from './Filters';
import PaginationCustom from './Pagination';

const NewTableComponent = ({ btnName, pageName, showAddBtn = false, onAddClick, columns = [],
    data = [], currentPage, setCurrentPage, limit, setLimit, totalItems, totalPages,
    onSearch, loading = false, setSearchFilters, searchFilters, paginationLoading = false, showPagination = true, showFilter = true, tagsOptions = [] }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
    const [openFilter, setOpenFilter] = useState(null);
    const { userDropdownData } = useSelector((state) => state.users);

    const previousSearchTerm = useRef('');

    const filterRef = useRef(null);

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSearchTerm(searchTerm);
        }, 500);

        return () => {
            clearTimeout(timer);
        };
    }, [searchTerm]);

    useEffect(() => {
        if (onSearch && debouncedSearchTerm !== previousSearchTerm.current) {
            previousSearchTerm.current = debouncedSearchTerm;
            onSearch(debouncedSearchTerm);
        }
    }, [debouncedSearchTerm, onSearch]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (filterRef.current && !filterRef.current.contains(event.target) && !event.target.closest('.select-clear-button')) {
                setOpenFilter(null);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div>
            <div className='wrapper_data_table'>
                {
                    showFilter &&
                    <div className='table_header_search'>
                        <div>
                            {searchIcon}
                            <input
                                type="text"
                                placeholder="Search"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            {
                                searchTerm.length > 0 &&
                                <span onClick={() => {
                                    setSearchTerm('')
                                }}><MdOutlineClose /></span>
                            }
                        </div>
                        {
                            showAddBtn && (
                                <button className='add_btn' style={{ minWidth: pageName ? "215px" : "120px" }} onClick={onAddClick}>
                                    + {btnName}
                                </button>
                            )
                        }
                    </div>
                }
                {
                    columns.length > 0 && showFilter && <div className='table_column'>
                        {
                            columns.filter((column) => column?.tableColumn === true).map((column, index) => {
                                const filterObj = searchFilters?.[column.filterName];
                                const isActive = filterObj?.filter_type && filterObj?.value;

                                return (
                                    <div key={index}>
                                        {isActive ? (
                                            <>
                                                <div
                                                    className='filter_chip'
                                                    style={{ display: 'inline-flex', alignItems: 'center', cursor: 'pointer' }}
                                                    onClick={() => setOpenFilter(column.filterName)}
                                                >
                                                    {column?.name || column.filterName}: {filterObj.filter_type.replace(/_/g, ' ')} "
                                                    {filterObj.filter_type === 'one_of'
                                                        ? Array.isArray(filterObj.value)
                                                            ? filterObj.value
                                                                .map(id => {
                                                                    const label = userDropdownData.find(u => u.value === id)?.label || id;
                                                                    return label === 'in_progress' ? 'In Progress' : label;
                                                                })
                                                                .join(', ')
                                                            : (filterObj.value === 'in_progress' ? 'In Progress' : filterObj.value)
                                                        : (filterObj.value === 'in_progress' ? 'In Progress' : filterObj.value)
                                                    }"

                                                    {/* {filterObj.filter_type === 'one_of'
                                                        ? Array.isArray(filterObj.value)
                                                            ? filterObj.value.map(id => userDropdownData.find(u => u.value === id)?.label || id).join(', ')
                                                            : filterObj.value
                                                        : filterObj.value
                                                    }" */}

                                                    {/* {filterObj.filter_type === 'one_of'
                                                        ? Array.isArray(filterObj.value)
                                                            ? filterObj.value.join(', ')
                                                            : filterObj.value
                                                        : filterObj.value
                                                    } */}
                                                    <IoIosCloseCircle
                                                        style={{ cursor: 'pointer', marginLeft: 6 }}
                                                        onClick={e => {
                                                            e.stopPropagation();
                                                            setSearchFilters(prev => {
                                                                const updated = { ...prev };
                                                                delete updated[column.filterName];
                                                                return updated;
                                                            })
                                                        }}
                                                    />
                                                </div>
                                                {openFilter === column.filterName && (
                                                    <Filters
                                                        closeFilter={() => setOpenFilter(null)}
                                                        searchFilters={searchFilters}
                                                        setSearchFilters={setSearchFilters}
                                                        filterName={column.filterName}
                                                        type={column.type}
                                                        component={column.component || null}
                                                        {...(column.filterName === "tagsFilter" ? { tagsOptions } : {})}
                                                        setWrapperRef={el => { filterRef.current = el; }}
                                                        removeFilter={e => {
                                                            setSearchFilters(prev => {
                                                                const updated = { ...prev };
                                                                delete updated[column.filterName];
                                                                return updated;
                                                            })
                                                        }}
                                                    />
                                                )}
                                            </>
                                        ) : (
                                            <>
                                                <span onClick={() => setOpenFilter(column.filterName)}>
                                                    {column.name}
                                                    <FiChevronDown />
                                                </span>
                                                {openFilter === column.filterName && (
                                                    <Filters
                                                        closeFilter={() => setOpenFilter(null)}
                                                        searchFilters={searchFilters}
                                                        setSearchFilters={setSearchFilters}
                                                        filterName={column.filterName}
                                                        type={column.type}
                                                        component={column.component || null}
                                                        {...(column.filterName === "tagsFilter" ? { tagsOptions } : {})}
                                                        setWrapperRef={el => { filterRef.current = el; }}
                                                        removeFilter={e => {
                                                            setSearchFilters(prev => {
                                                                const updated = { ...prev };
                                                                delete updated[column.filterName];
                                                                return updated;
                                                            })
                                                        }}
                                                    />
                                                )}
                                            </>
                                        )}
                                    </div>
                                );
                            })
                        }
                    </div>
                }
                {
                    loading ?
                        <div className='loading_spinner'><Spinner animation="grow" /></div> :
                        <div className='data_table_main'>
                            <DataTable
                                columns={columns}
                                data={data}
                                pointerOnHover
                                striped={false}
                                dense={false}
                                customStyles={customStyles}
                            />
                        </div>
                }
            </div>

            {
                !paginationLoading &&
                showPagination &&
                <PaginationCustom
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    limit={limit}
                    setLimit={setLimit}
                    totalItems={totalItems}
                    totalPages={totalPages}
                />
            }
        </div>
    )
}

export default NewTableComponent